import { render, staticRenderFns } from "./OrdersDetail.vue?vue&type=template&id=283b49a4&scoped=true"
import script from "./OrdersDetail.vue?vue&type=script&lang=js"
export * from "./OrdersDetail.vue?vue&type=script&lang=js"
import style0 from "./OrdersDetail.vue?vue&type=style&index=0&id=283b49a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b49a4",
  null
  
)

export default component.exports